
import { BasicEnvironmentGlobals, DictionaryUtil, IEnvironmentGlobals } from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { appVersion, assetsVersion, PokerGameVersion} from "./version/PokerGameVersion";

import { PokerItemLib1Version } from "./version/PokerItemLib1Version";
import { PokerItemLib2Version } from "./version/PokerItemLib2Version";
import { PokerItemLib3Version } from "./version/PokerItemLib3Version";
import { PokerItemLib4Version } from "./version/PokerItemLib4Version";
import { PokerItemsXMLVersion } from "./version/PokerItemsXMLVersion";

export class Poker2EnvironmentGlobals extends BasicEnvironmentGlobals implements IEnvironmentGlobals {

    private _clientInstanceHash: number = -1;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    public get itemXMLUrl(): string {
        return this.baseURL + "/config/" + this.gameTitle + "Items_v" + this.versionNumberItemsXML + "." + this.zipSuffix;
    }

    public get availableLanguages(): any[] {
        var availableLanguagesArray: any[] = [];
        if (typeof this.langVersionDict === "undefined" || this.langVersionDict === null) {
            return [];
        }
        for (var lang of DictionaryUtil.getKeys(this.langVersionDict)) {
            availableLanguagesArray.push(lang);
        }
        return availableLanguagesArray;
    }

    public get standardLanguage(): string {
        return "en";
    }

    public get cdnSubDomain(): string {
        return "data";
    }

    public get gameId(): number {
        return 1;
    }

    public get gameTitle(): string {
        return "Poker";
    }

    public get versionNumberGame(): string {
        return 0.1.toString();
    }

    public get versionDateGame(): string {
        return 201201311804;
    }

    public get versionNumberItemLib1(): string {
        return 55.toString();
    }

    public get versionNumberItemLib2(): string {
        return 36.toString();
    }

    public get versionNumberItemLib3(): string {
        return 35.toString();
    }

    public get versionNumberItemLib4(): string {
        return 20.toString();
    }

    public get buildNumberGame(): string {
        return 390.toString();
    }

    public get numOfItemLibs(): number {
        return 4;
    }

    public get versionNumberItemsXML(): string {
        return 49.toString();
    }

    public get analyticsTrackingPath(): string {
        return "/goodgamePoker";
    }

    public get showLoadingText(): boolean {
        return true;
    }

    public get useABTest(): boolean {
        return false;
    }

    public get hasInstances(): boolean {
        return (<any>window).ggs.worldAssignment.facade.networkInstances.length > 1;
    }

    public get clientInstanceHash(): number {
        return this._clientInstanceHash;
    }

    public set clientInstanceHash(value: number) {
        this._clientInstanceHash = value;
    }

    public get versionText(): string {
        return `V${appVersion} A${assetsVersion} XML${this.versionNumberItemsXML}`;
        // server version from VCK command is not ready yet
        // return `V${appVersion} A${assetsVersion} XML${this.versionNumberItemsXML} S${this.buildNumberServer}`;
    }

    // For Testing
	/*		override public function get isFirstVisit():Boolean{
				return true;
			}*/

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set availableLanguages(value/*:Array*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "availableLanguages").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set standardLanguage(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "standardLanguage").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set cdnSubDomain(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "cdnSubDomain").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set gameId(value/*:int*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "gameId").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set gameTitle(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "gameTitle").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set versionNumberGame(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "versionNumberGame").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set versionDateGame(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "versionDateGame").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set versionNumberItemLib1(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "versionNumberItemLib1").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set buildNumberGame(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "buildNumberGame").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set numOfItemLibs(value/*:int*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "numOfItemLibs").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set versionNumberItemsXML(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "versionNumberItemsXML").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set analyticsTrackingPath(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "analyticsTrackingPath").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set showLoadingText(value/*:Boolean*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "showLoadingText").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set useABTest(value/*:Boolean*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicEnvironmentGlobals.prototype, "useABTest").set.call(this, value);
    }
}

classImplementsInterfaces(Poker2EnvironmentGlobals, "IEnvironmentGlobals");
